import * as ToggleGroup from '@radix-ui/react-toggle-group';
import { MonitorCog, Sun } from 'lucide-react';
import { useTheme, type ThemeName } from '@/theme/theme';

/** Switches between the Command (dark ops) and Field (sunlit) themes. */
export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  return (
    <ToggleGroup.Root
      type="single"
      value={theme}
      onValueChange={(v) => v && setTheme(v as ThemeName)}
      aria-label="Display theme"
      className="inline-flex overflow-hidden rounded-lg border border-border bg-surface-2 text-xs"
    >
      <ToggleGroup.Item
        value="command"
        aria-label="Command theme (dark)"
        className="flex items-center gap-1.5 px-2.5 py-1.5 text-muted transition-colors data-[state=on]:bg-accent/15 data-[state=on]:text-accent"
      >
        <MonitorCog size={14} aria-hidden /> Command
      </ToggleGroup.Item>
      <ToggleGroup.Item
        value="field"
        aria-label="Field theme (sunlit, high contrast)"
        className="flex items-center gap-1.5 px-2.5 py-1.5 text-muted transition-colors data-[state=on]:bg-accent/15 data-[state=on]:text-accent"
      >
        <Sun size={14} aria-hidden /> Field
      </ToggleGroup.Item>
    </ToggleGroup.Root>
  );
}
